import { useRecoilValue } from "recoil";
import CBSearchAutocompleteController from "../controller/CBSearchAutocompleteController";
import { sapEnumState } from "../../../state/customerbaseState";
import { useFormContext } from "react-hook-form";
import { CustomerSearchFilters } from "../../../types";

const CBPartnerTypeSearchFilter = () => {

    const sapEnum = useRecoilValue(sapEnumState);
    const formContext = useFormContext<CustomerSearchFilters>();
    
    return (
        <CBSearchAutocompleteController 
            idField="partnerType"
            formName="partnerType"
            label="partnerType"
            options={sapEnum.partnerTypes}
            onChange={(value) => formContext.setValue("partnerType", value? value.value : "")}
        />
    )

}

export default CBPartnerTypeSearchFilter;